module.exports = __webpack_public_path__ + "images/new_assessment_intro_default.png";